import React from "react";

// utils
import { twMerge } from "tailwind-merge";

// types
import { objectsToString } from "@/components/utils";
import clsx from "clsx";
import {
  children,
  className,
  propTypesChildren,
  propTypesClassName,
} from "../utils/types";
import { list } from "./listStyle";

export interface ListItemPrefixProps extends React.ComponentProps<"div"> {
  className?: className;
  children: children;
}

export const ListItemPrefix = React.forwardRef<
  HTMLDivElement,
  ListItemPrefixProps
>(({ className, children, ...rest }, ref) => {
  // 1. init
  const { styles } = list;

  // 2. set styles
  const listItemPrefixClasses = twMerge(
    clsx(objectsToString(styles?.base?.itemPrefix)),
    className
  );

  return (
    <div {...rest} ref={ref} className={listItemPrefixClasses}>
      {children}
    </div>
  );
});

ListItemPrefix.propTypes = {
  className: propTypesClassName,
  children: propTypesChildren,
};

ListItemPrefix.displayName = "ListItemPrefix";

// export default ListItemPrefix;
